import { generatePath } from "react-router-dom";
import { ACCOUNTS, GET_ACCOUNT_USERS, LEAVE_ACCOUNT } from "../apiEndPoints";
import { api, convertKeysToCamelCase, convertKeysToSnakeCase } from "./api";

export const accountApiSlice = api.injectEndpoints({
  endpoints: (builder) => ({
    getAccount: builder.query({
      query: (accountId: string) => ({
        url: generatePath(ACCOUNTS, { accountId }),
        method: "GET",
      }),
      transformResponse: (response) => convertKeysToCamelCase(response),
      providesTags: (result, error, accountId) => [
        { type: "Account", accountId },
      ],
    }),
    updateAccount: builder.mutation({
      query: ({ accountId, ...rest }) => ({
        url: generatePath(ACCOUNTS, { accountId }),
        method: "PATCH",
        body: convertKeysToSnakeCase(rest),
      }),
      invalidatesTags: (result, error, { accountId }) => [
        { type: "Account", id: accountId },
        { type: "User" },
      ],
    }),
    deleteAccount: builder.mutation({
      query: (accountId: string) => ({
        url: generatePath(ACCOUNTS, { accountId }),
        method: "DELETE",
      }),
      invalidatesTags: (result, error, accountId) => [
        { type: "Account", id: accountId },
      ],
    }),
    getAccountUsers: builder.query({
      query: (accountId: string) => ({
        url: generatePath(GET_ACCOUNT_USERS, { accountId }),
        method: "GET",
      }),
      transformResponse: (response) => convertKeysToCamelCase(response),
      providesTags: (result, error, accountId) => [
        { type: "AccountUsers", id: accountId },
      ],
    }),
    leaveAccount: builder.mutation({
      query: (accountId: string) => ({
        url: generatePath(LEAVE_ACCOUNT, { accountId }),
        method: "DELETE",
      }),
      invalidatesTags: (result, error, accountId) => [
        { type: "Account", id: accountId },
        { type: "AccountUsers", id: accountId },
      ],
    }),
  }),
});

export const {
  useGetAccountQuery,
  useUpdateAccountMutation,
  useDeleteAccountMutation,
  useGetAccountUsersQuery,
  useLeaveAccountMutation,
} = accountApiSlice;
